import React from 'react';
import Selector from 'components/DesignSystem/Selector';
import useVariables from 'hooks/Meteorology/Agro/WaterBalanceSequential/Maps/useVariables';
import './index.scss';

export default function VariableSelect() {
  const { variables, variable, setVariable } = useVariables();

  return (
    <Selector
      label="Variável"
      placeholder="Selecionar"
      className="water-balance-variable-select"
      value={variable}
      setValue={setVariable}
    >
      {variables.map((v) => (
        <option key={v.value} value={v.value}>
          {v.label}
        </option>
      ))}
    </Selector>
  );
}
